const CONTEXT = {
  credentials: "omit",
  headers: {
    region: "us-west-2",
    authenticationType: "API_KEY",
    "x-api-key": process.env.NEXT_PUBLIC_PROD_GRAPHQL_API,
  },
};

export default CONTEXT;
